export const EntityType = {
    PRODUCT: 0,
    CATEGORY: 1,
    MASTERTAG: 2
};

export function entityTypeToString(entityType) {
    switch (entityType) {
        case EntityType.PRODUCT:
            return "Product";
        case EntityType.CATEGORY:
            return "Category";
        case EntityType.MASTERTAG:
            return "MasterTag";
        default:
            return null;
    }
}